import { h, Fragment } from 'preact';
import style from './style.css';

import Header from '../../../components/header';
import Footer from '../../../components/footer';

import { route } from 'preact-router';

import CustomButton from '../../../components/button';

import { loadLogin } from './controller';
import { logged, showAlert, showSpinner, hideSpinner } from '../../../utils';
import Spinner from '../../../components/spinner';
import { GlobalState } from '../../../states/global-state';
import SignupSubTitle from '../../../components/common/signup-subtitle';
import SignupTitle from '../../../components/common/signup-title';

const RegisterNotify = props => {
  const dashboardHandler = () => {
    //got to dashboard
    // console.log('go to dashboard');
    route('/redirect/dashboard');
  };

  const kycHandler = () => {
    try {
      //go to kyc
      console.log('go to kyc');
      // route('/kyc', true);
      showSpinner();

      loadLogin().then(res => {
        hideSpinner();
        logged(res);
      });
    } catch (err) {
      hideSpinner();
      showAlert({
        title: 'Error',
        icon: 'error',
        text: err.message,
        allowOutsideClick: false,
        showConfirmButton: true,
      });
    }
  };

  return (
    <Fragment>
      <Header />
      <Spinner />
      <div class="container-xl">
        <br />

        <SignupTitle>Account Activation Success</SignupTitle>
        <br />
        <SignupSubTitle>
          To start investing, you need to complete your account information
          (KYC,FATCA, Risk Profile)
        </SignupSubTitle>

        <div style={{ maxWidth: '600px', margin: 'auto' }}>
          <div class="text-center">
            <CustomButton
              type="submit"
              class="btn btn-danger"
              onClick={dashboardHandler}
            >
              Later
            </CustomButton>
            &nbsp; &nbsp;
            <CustomButton
              type="button"
              onClick={kycHandler}
              class="btn btn-success"
            >
              Ok
            </CustomButton>
          </div>
        </div>
      </div>

      <div style={{ height: '40vh' }} />

      <Footer />
    </Fragment>
  );
};

interface ResourceProps {
  title: string;
  description: string;
  link: string;
}

const Resource = (props: ResourceProps) => {
  return (
    <a href={props.link} class={style.resource}>
      <h2>{props.title}</h2>
      <p>{props.description}</p>
    </a>
  );
};

export default RegisterNotify;
